/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use this for songwriting or language learning?`)
};

const es_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo usarlo para componer canciones o aprender idiomas?`)
};

const de_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich das zum Songwriting oder Sprachenlernen nutzen?`)
};

const nl_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik dit gebruiken voor songteksten of taal leren?`)
};

const fr_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je l'utiliser pour l'écriture de chansons ou l'apprentissage des langues ?`)
};

const it_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usarlo per la scrittura di canzoni o per imparare una lingua?`)
};

const pt_br2_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usar isso para composição de letras ou aprendizado de idiomas?`)
};

const pt_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso utilizar isto para composição de letras ou aprendizagem de línguas?`)
};

const ja_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作詞や語学学習にも使えますか？`)
};

const zh_syl_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个工具可以用于歌词创作或语言学习吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_faq4_q", locale)
	if (locale === "en") return en_syl_hub_faq4_q(inputs)
	if (locale === "es") return es_syl_hub_faq4_q(inputs)
	if (locale === "de") return de_syl_hub_faq4_q(inputs)
	if (locale === "nl") return nl_syl_hub_faq4_q(inputs)
	if (locale === "fr") return fr_syl_hub_faq4_q(inputs)
	if (locale === "it") return it_syl_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_faq4_q(inputs)
	if (locale === "pt") return pt_syl_hub_faq4_q(inputs)
	if (locale === "ja") return ja_syl_hub_faq4_q(inputs)
	return zh_syl_hub_faq4_q(inputs)
};